import { useUIStore } from '@/store/uiStore';
import { cn } from '@/utils/cn.utils';

const typeStyles = {
  success: 'bg-green-50 border-green-200 text-green-800',
  error:   'bg-red-50   border-red-200   text-red-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
  info:    'bg-blue-50  border-blue-200  text-blue-800',
};

/**
 * Conteneur global de toasts.
 * À monter une seule fois dans App.tsx, hors du router.
 */
export default function ToastContainer() {
  const { toasts, dismissToast } = useUIStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50 flex flex-col gap-2 p-4 pt-safe pointer-events-none">
      {toasts.map(toast => (
        <div
          key={toast.id}
          onClick={() => dismissToast(toast.id)}
          className={cn(
            'w-full max-w-sm mx-auto px-4 py-3 rounded-xl border shadow-sm',
            'pointer-events-auto cursor-pointer animate-slide-up',
            'text-sm font-medium',
            typeStyles[toast.type]
          )}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
}
